import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { PromoWithTitle } from "../onboarding/sidebar/PromoWithTitle";

import { CreateAccountInviteeContent } from "./CreateAccountInviteeContent";
import { InviteeNotFound } from "./InviteeNotFound";

import { useGetInviteeData } from "@/queries/workspace";
import aboutUserPromo from "@/assets/onboarding/about-user.png";
import { useOnboardingSidebar } from "@/context/onboarding-sidebar-context";
import LoadingSpinner from "@/components/LoadingSpinner";
import { GoogleReCaptchaProvider } from "@/providers/GoogleReCaptchaProvider";
import { AUTH_CONFIG, IS_RECAPTCHA_ENABLED } from "@/constants";
import { displayToast } from "@/utils/toast";
import { ToastType } from "@/enums/toast";

export const CreateAccountInvitee = () => {
  const { invitee } = useParams();
  const { setSidebarContent } = useOnboardingSidebar();
  const navigate = useNavigate();
  const { isOnPrem, hasSSO } = AUTH_CONFIG;

  useEffect(() => {
    const sidebarContent = (
      <PromoWithTitle
        title="Build AI with experts"
        titleClassName="text-center"
        containerClassName="flex-1 justify-center items-center"
        position="bottom"
        image={aboutUserPromo}
      />
    );
    setSidebarContent(sidebarContent, "create-account-invitee");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: inviteeData, isLoading: isLoadingInviteeData } = useGetInviteeData({
    invite_code: invitee ?? "",
  });

  useEffect(() => {
    if (isOnPrem && hasSSO) {
      displayToast("Please use SSO to create an account.", ToastType.warning);

      setTimeout(() => {
        navigate(`/login?email=${encodeURIComponent(inviteeData?.[0]?.invitee_email ?? "")}`);
      }, 500);
    }
  }, [isOnPrem, hasSSO, navigate, inviteeData]);

  if (!inviteeData && !isLoadingInviteeData) {
    return <InviteeNotFound />;
  }

  return (
    <div className="mx-auto flex min-h-full w-full flex-col justify-center py-8">
      {isLoadingInviteeData ? (
        <div className="flex flex-col items-center justify-center">
          <LoadingSpinner />
        </div>
      ) : (
        <CreateAccountInviteeContent inviteeData={inviteeData ?? []} />
      )}
    </div>
  );
};

export const CreateAccountInviteeWithRecaptcha = () => (
  <GoogleReCaptchaProvider enabled={IS_RECAPTCHA_ENABLED}>
    <CreateAccountInvitee />
  </GoogleReCaptchaProvider>
);
